import React, { FormEvent, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
	Box,
	Button,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
	Select,
	Switch,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";

import {
	checkExistEmail,
	checkExistUsername,
	checkPassword,
	checkPhoneNumber,
} from "../../../utils/Validation";

import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import RoleModel from "../../../../models/RoleModel";
import {getAllRoles} from "../../../../api/RoleApi";
import {get1User} from "../../../../api/UserApi";
import {getUsernameByToken} from "../../../utils/JwtService";
import {endpointBE} from "../../../utils/Constant";
import { UserModel } from "../../../../models/UserModel";


interface UserFormProps {
	option: string;
	setKeyCountReload?: any;
	id: number;
	handleCloseModal: any;
}

export const UserForm: React.FC<UserFormProps> = (props) => {
	// Các biến cần thiết
	 const [user, setUser] = useState<UserModel>({
		 idUser: "",
		 dateOfBirth: "",
		 deliveryAddress: "",
		 email: "",
		 firstName: "",
		 lastName: "",
		 gender: false,
		 phoneNumber: "",
		 username: "",
		 password: "",
		 avatar: "",
		 enabled: true,
		 roles: ["USER"],
	 });
	const [avatar, setAvatar] = useState<File | null>(null);
	const [previewAvatar, setPreviewAvatar] = useState("");
	const [roles, setRoles] = useState<RoleModel[]>([]);
	// Khi submit thì btn loading ...
	const [statusBtn, setStatusBtn] = useState(false);

	// Khai báo các biến lỗi
	const [errorUsername, setErrorUsername] = useState("");
	const [errorEmail, setErrorEmail] = useState("");
	const [errorPassword, setErrorPassword] = useState("");
	const [errorPhoneNumber, setErrorPhoneNumber] = useState("");

	// Lấy ra role
	useEffect(() => {
		getAllRoles().then((response) => {
			setRoles(response);
		});
	}, []);

	useEffect(() => {
  if (props.option === "update") {
    get1User(props.id).then((response) => {
      const formattedDate = response.dateOfBirth
        ? new Date(response.dateOfBirth).toISOString().split("T")[0]
        : "";

      setUser({
        ...response,
		idUser: response.idUser,
        dateOfBirth: formattedDate,
        password: "",           // luôn trống, người dùng nhập nếu muốn đổi
        roles: response.roles || ["USER"],
      });
      setPreviewAvatar(response.avatar ?? "");
    });
  }
}, [props.id, props.option]);


	function hanleSubmit(event: FormEvent<HTMLFormElement>) {
	event.preventDefault();

	const token = localStorage.getItem("token");

	// Ngăn không cho update chính tài khoản đang đăng nhập
	if (getUsernameByToken() === user.username) {
		toast.warning("Bạn không thể cập nhật tài khoản bạn đang sử dụng");
		return;
	}

	setStatusBtn(true);

	const endpoint =
		props.option === "add"
			? endpointBE + "/user/add-user"
			: endpointBE + `/user/update-user/${user.idUser}`;
	const method = props.option === "add" ? "POST" : "PUT";

	// Map dữ liệu FE sang đúng DTO BE
	// const body = {
	// id: user.idUser,
    // name: user.username || null,
    // email: user.email || null,
    // passwordHash: user.password || null,
    // enabled: user.enabled,
    // firstName: user.firstName || null,
    // lastName: user.lastName || null,
    // phoneNumber: user.phoneNumber || null,
    // deliveryAddress: user.deliveryAddress || null,
    // dateOfBirth: user.dateOfBirth || null,
    // gender: user.gender,
    // avatar: user.avatar || null,
    // roles: user.roles.length > 0 ? user.roles : null
	// };
	const formData = new FormData();

	// ===== MAP Y CHANG DTO =====
	formData.append("id", user.idUser);

	formData.append("name", user.username || "");
	formData.append("email", user.email || "");
	formData.append("passwordHash", user.password || "");

	formData.append("enabled", String(user.enabled));

	formData.append("firstName", user.firstName || "");
	formData.append("lastName", user.lastName || "");

	formData.append("phoneNumber", user.phoneNumber || "");
	formData.append("deliveryAddress", user.deliveryAddress || "");

	formData.append("dateOfBirth", user.dateOfBirth || "");
	formData.append("gender", String(user.gender));

	// ❌ QUAN TRỌNG: KHÔNG gửi avatar base64 nữa
	// formData.append("avatar", user.avatar); ❌ XÓA

	// ===== ROLES =====
	if (user.roles && user.roles.length > 0) {
		user.roles.forEach((role) => {
			formData.append("roles", role); // ✅ đúng kiểu BE nhận List<string>
		});
	}

	// ===== FILE =====
	if (avatar) {
		formData.append("file", avatar); // 👈 cái này BE sẽ nhận IFormFile
	}

	toast.promise(
		// fetch(endpoint, {
		// 	method: method,
		// 	headers: {
		// 		Authorization: `Bearer ${token}`,
		// 		"Content-Type": "application/json",
		// 	},
		// 	body: JSON.stringify(body),
		// })
		fetch(endpoint, {
		method: method,
		headers: {
			Authorization: `Bearer ${token}`,
		},
		body: formData,
	})
			.then((response) => {
				if (response.ok) {
					setUser({
						idUser: "",
						username: "",
						password: "",
						email: "",
						enabled: true,
						firstName: "",
						lastName: "",
						phoneNumber: "",
						deliveryAddress: "",
						dateOfBirth: "",
						gender: false,
						avatar: "",
						roles: ["USER"],
					});
					setAvatar(null);
					setPreviewAvatar("");
					setStatusBtn(false);
					if (props.setKeyCountReload) props.setKeyCountReload(Math.random());
					props.handleCloseModal();
					toast.success(
						props.option === "add"
							? "Thêm người dùng thành công"
							: "Cập nhật người dùng thành công"
					);
				} else {
					setStatusBtn(false);
					toast.error("Gặp lỗi trong quá trình xử lý người dùng");
				}
			})
			.catch((error) => {
				console.log(error);
				setStatusBtn(false);
				toast.error("Gặp lỗi trong quá trình xử lý người dùng");
			}),
		{ pending: "Đang trong quá trình xử lý ..." }
	);
}
	// function handleImageUpload(event: React.ChangeEvent<HTMLInputElement>) {
	// 	const inputElement = event.target as HTMLInputElement;

	// 	if (inputElement.files && inputElement.files.length > 0) {
	// 		const selectedFile = inputElement.files[0];

	// 		const reader = new FileReader();

	// 		reader.onload = (e: any) => {
			
	// 			const thumnailBase64 = e.target?.result as string;
			
	// 			setAvatar(selectedFile);
	// 			setPreviewAvatar(URL.createObjectURL(selectedFile));
	// 			setUser({ ...user, avatar: thumnailBase64 });
	// 		};
	// 		// Đọc tệp dưới dạng chuỗi base64
	// 		reader.readAsDataURL(selectedFile);
	// 	}
	// }
	function handleImageUpload(event: React.ChangeEvent<HTMLInputElement>) {
	const inputElement = event.target;

	if (inputElement.files && inputElement.files.length > 0) {
		const file = inputElement.files[0];

		setAvatar(file);
		setPreviewAvatar(URL.createObjectURL(file)); // 
	}
}
	 const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		 const dateString = e.target.value;
		 setUser({
			 ...user,
			 dateOfBirth: dateString,
		 });
	 };

	return (
		<div>
			<Typography className='text-center' variant='h4' component='h2'>
				{props.option === "add"
					? "TẠO NGƯỜI DÙNG"
					: props.option === "update"
					? "SỬA NGƯỜI DÙNG"
					: "XEM CHI TIẾT"}
			</Typography>
			<hr />
			<div className='container px-5'>
				<form onSubmit={hanleSubmit} className='form'>
					<input type='hidden' value={user.idUser} hidden />
					<div className='row'>
						<div className='col-6'>
							<Box
								sx={{
									"& .MuiTextField-root": { mb: 3 },
								}}
							>
								<TextField
									required
									id='filled-required'
									label='Tên tài khoản'
									style={{ width: "100%" }}
									error={errorUsername.length > 0 ? true : false}
									helperText={errorUsername}
									value={user.username}
									InputProps={{
										disabled:
											props.option === "update" ? true : false,
									}}
									onChange={(e: any) => {
										setUser({ ...user, username: e.target.value });
										setErrorUsername("");
									}}
									onBlur={(e: any) => {
										checkExistUsername(
											setErrorUsername,
											e.target.value
										);
									}}
									size='small'
								/>

								<TextField
									required={props.option === "update" ? false : true}
									id='filled-required'
									type='password'
									label='Mật khẩu'
									style={{ width: "100%" }}
									error={errorPassword.length > 0 ? true : false}
									helperText={errorPassword}
									value={user.password}
									onChange={(e: any) => {
										setUser({ ...user, password: e.target.value });
										setErrorPassword("");
									}}
									onBlur={(e: any) => {
										checkPassword(setErrorPassword, e.target.value);
									}}
									size='small'
								/>

								<TextField
									required
									id='filled-required'
									label='Email'
									type='email'
									style={{ width: "100%" }}
									error={errorEmail.length > 0 ? true : false}
									helperText={errorEmail}
									value={user.email}
									InputProps={{
										disabled:
											props.option === "update" ? true : false,
									}}
									onChange={(e: any) => {
										setUser({ ...user, email: e.target.value });
										setErrorEmail("");
									}}
									onBlur={(e: any) => {
										checkExistEmail(setErrorEmail, e.target.value);
									}}
									size='small'
								/>

								<TextField
									required
									id='filled-required'
									label='Số điện thoại'
									style={{ width: "100%" }}
									error={errorPhoneNumber.length > 0 ? true : false}
									helperText={errorPhoneNumber}
									value={user.phoneNumber}
									onChange={(e: any) => {
										setUser({
											...user,
											phoneNumber: e.target.value,
										});
										setErrorPhoneNumber("");
									}}
									onBlur={(e: any) => {
										checkPhoneNumber(
											setErrorPhoneNumber,
											e.target.value
										);
									}}
									size='small'
								/>

								 <TextField
									 required
									 id='filled-required'
									 label='Ngày sinh'
									 style={{ width: "100%" }}
									 type='date'
									 value={user.dateOfBirth}
									 onChange={handleDateChange}
									 size='small'
								 />
								 <FormControlLabel
									control={
										<Switch
											checked={user.enabled}
											onChange={(e) =>
												setUser({ ...user, enabled: e.target.checked })
											}
										/>
									}
									label='Kích hoạt tài khoản'
									/>
							</Box>
						</div>
						<div className='col-6'>
							<Box
								sx={{
									"& .MuiTextField-root": { mb: 3 },
								}}
							>
								<TextField
									id='filled-required'
									label='Họ đệm'
									style={{ width: "100%" }}
									value={user.firstName}
									onChange={(e: any) =>
										setUser({ ...user, firstName: e.target.value })
									}
									size='small'
								/>

								<TextField
									required
									id='filled-required'
									label='Tên'
									style={{ width: "100%" }}
									value={user.lastName}
									onChange={(e: any) =>
										setUser({ ...user, lastName: e.target.value })
									}
									size='small'
								/>

								<TextField
									id='filled-required'
									label='Địa chỉ'
									style={{ width: "100%" }}
									value={user.deliveryAddress}
									onChange={(e: any) =>
										setUser({
											...user,
											deliveryAddress: e.target.value,
										})
									}
									size='small'
								/>
								<FormControl fullWidth size='small' sx={{ mb: 3 }}>
								<InputLabel id='gender-select-label'>Giới tính</InputLabel>
								<Select
									labelId='gender-select-label'
									id='gender-select'
									value={user.gender}
									label='Giới tính'
									onChange={(e: any) =>
										setUser({ ...user, gender: e.target.value === "true" })
									}
								>
									<MenuItem value="true">Nam</MenuItem>
									<MenuItem value="false">Nữ</MenuItem>
								</Select>
							</FormControl>

								 {/* <FormControl fullWidth size='small'>
									 <InputLabel id='demo-simple-select-label'>Vai trò</InputLabel>
									 <Select
										 labelId='demo-simple-select-label'
										 id='demo-simple-select'
										 value={user.roles[0] || ""}
										 label='Vai trò'
										 onChange={(e: any) =>
											 setUser({
												 ...user,
												 roles: [e.target.value],
											 })
										 }
									 >
										 {roles.map((role) => (
											 <MenuItem value={role.nameRole} key={role.idRole}>
												 {role.nameRole}
											 </MenuItem>
										 ))}
									 </Select>
								 </FormControl> */}
								 <FormControl fullWidth size='small'>
								<InputLabel id='role-select-label'>Vai trò</InputLabel>
								<Select
									labelId='role-select-label'
									id='role-select'
									multiple
									value={user.roles}
									onChange={(e: any) =>
										setUser({ ...user, roles: e.target.value })
									}
									renderValue={(selected) => (selected as string[]).join(", ")}
								>
									{roles.map((role) => (
										<MenuItem key={role.idRole} value={role.nameRole}>
											{role.nameRole}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							</Box>
						</div>
						<div className='d-flex align-items-center mt-3'>
							<Button
								size='small'
								component='label'
								variant='outlined'
								startIcon={<CloudUpload />}
							>
								Tải ảnh avatar
								<input
									style={{ opacity: "0", width: "10px" }}
									// required
									type='file'
									accept='image/*'
									onChange={handleImageUpload}
									alt=''
								/>
							</Button>
							<span className='ms-3'>{avatar?.name}</span>
							<img src={previewAvatar} alt='' width={100} />
						</div>
					</div>
					<LoadingButton
						className='my-3'
						type='submit'
						loading={statusBtn}
						variant='outlined'
						sx={{ width: { xs: "100%", md: "25%" }, padding: "10px" }}
					>
						{props.option === "add" ? "Tạo người dùng" : "Lưu người dùng"}
					</LoadingButton>
				</form>
			</div>
		</div>
	);
};
